export const ProductGroupComparativeSalesPerf = {
    "sections": [
      {
        "columns": 4,
        "rows": 1,
        "visual": {
          "id": 14,
          "type": "summary",
          "colorTheme": "colorTheme1",
          "title": "Sales Summary",
          "binding": {
            "data": {
              "title": '',
              "value": '',
              "displayTarget": true,
              "endpoint": "PG01",
              "parameters": [
                { "key": "FromMonth", "value": "2024" },
                { "key": "FromYear", "value": "1" },
                { "key": "ToMonth", "value": "2024" },
                { "key": "ToYear", "value": "1" },
                { "key": "ConfigTypeCode", "value": "" },
                { "key": "ItemGroupCode", "value": "" }
              ]
            },
            "context": {
              "point": {
                "onClick": {
  
                }
              }
            }
          }
        }
      },
      {
        "columns": 4,
        "rows": 1,
        "visual": {
          "id": 1,
          "type": "pie",
          "colorTheme": "colorTheme1",
          "title": "Share by Region",
          "binding": {
            "data": {
              "title": 'RegionCode',
              "value": 'Share',
              "tooltip": 'ActualSales',
              "currency": true,
              "percent": true,
              "endpoint": "PG03",
              "parameters": [
                { "key": "FromMonth", "value": "2024" },
                { "key": "FromYear", "value": "1" },
                { "key": "ToMonth", "value": "2024" },
                { "key": "ToYear", "value": "1" },
                { "key": "ItemGroupCode", "value": "" },
                { "key": "ConfigTypeCode", "value": "" }
              ]
            },
            "context": {
              "point": {
                "onClick": {
  
                }
              }
            }
          }
        }
      },
      {
        "columns": 4,
        "rows": 2,
        "visual": {
          "id": 1,
          "type": "bar",
          "title": "Product Sales",
          "colorTheme": 'colorTheme2',
          "orientation": "horizontal",
          "xAxis": "Sales",
          "yAxis": "",
          "binding": {
            "data": {
              "series": [
                {
                  "name": 'Sales',
                  "value": 'ActualSales',
                  "type": 'column'
                }
              ],
              "title": "ItemName",
              "endpoint": "PG03.3",
              "parameters": [
                { "key": "FromMonth", "value": "" },
                { "key": "FromYear", "value": "" },
                { "key": "ToMonth", "value": "" },
                { "key": "ToYear", "value": "" },
                { "key": "EmployeeCode", "value": "" },
                { "key": "ItemGroupCode", "value": "" },
                { "key": "ConfigTypeCode", "value": "" }
              ]
            },
            "context": {
              "point": {
                "onClick": {
  
                }
              }
            }
          }
        }
      },
      {
        "columns": 4,
        "rows": 1,
        "visual": {
          "id": 1,
          "type": "combo",
          "colorTheme": 'colorTheme1',
          "title": "Actual vs Target (% Performance)",
          "orientation": "vertical",
          "xAxis": "",
          "yAxis": "",
          "binding": {
            "data": {
              "series": [
  
                {
                  "name": 'Sales',
                  "value": 'Sales',
                  "type": 'column'
                },
                {
                  "name": 'Target',
                  "value": 'Target',
                  "type": 'column'
                },
                {
                  "name": 'Performance %',
                  "value": 'Performance',
                  "type": 'line',
                  "percent": true
                }
              ],
              "title": "Month",
              "endpoint": "PG02",
              "parameters": [
                { "key": "FromMonth", "value": "2024" },
                { "key": "FromYear", "value": "1" },
                { "key": "ToMonth", "value": "2024" },
                { "key": "ToYear", "value": "1" },
                { "key": "ConfigTypeCode", "value": "" },
                { "key": "ItemGroupCode", "value": "" }
              ]
            },
            "context": {
              "point": {
                "onClick": {
  
                }
              }
            }
          }
        }
      },
      {
        "columns": 4,
        "rows": 1,
        "visual": {
          "id": 1,
          "type": "combo",
          "colorTheme": 'colorTheme1',
          "title": "Actual Sales vs Last Year (% Growth)",
          "orientation": "vertical",
          "xAxis": "",
          "yAxis": "",
          "binding": {
            "data": {
              "series": [
  
                {
                  "name": 'Sales',
                  "value": 'ActualSales',
                  "type": 'column'
                },
                {
                  "name": 'LY Sales',
                  "value": 'LYSales',
                  "type": 'column'
                },
                {
                  "name": 'Growth %',
                  "value": 'Growth',
                  "type": 'line',
                  "percent": true
                }
              ],
              "title": "Month",
              "endpoint": "PG02.1",
              "parameters": [
                { "key": "FromMonth", "value": "2024" },
                { "key": "FromYear", "value": "1" },
                { "key": "ToMonth", "value": "2024" },
                { "key": "ToYear", "value": "1" },
                { "key": "ConfigTypeCode", "value": "" },
                { "key": "ItemGroupCode", "value": "" }
              ]
            },
            "context": {
              "point": {
                "onClick": {
  
                }
              }
            }
          }
        }
      },
      {
        "columns": 12,
        "rows": 2,
        "visual": {
          "id": 1,
          "type": "advancedTable",
          "colorTheme": "colorTheme1",
          "title": "District Sales",
          "binding": {
            "data": {
              "columns": [
                {
                  "name": 'DM Code',
                  "columnName": 'DistrictManagerCode',
                  "width": '200px',
                  "align": "left",
                  "sortable": true,
                  "sum": false
                },
                {
                  "name": 'District Manager Name',
                  "columnName": 'DistrictManagerName',
                  "width": '300px',
                  "align": "left",
                  "sortable": true,
                  "sum": false
                },
                {
                  "name": 'District Name',
                  "columnName": 'DistrictName',
                  "width": '300px',
                  "align": "left",
                  "sortable": true,
                  "sum": false
                },
                {
                  "name": 'Actual Sales',
                  "columnName": 'ActualSales',
                  "width": '140px',
                  "align": "right",
                  "sortable": true,
                  "sum": true
                },
                {
                  "name": 'Target Sales',
                  "columnName": 'TargetSales',
                  "width": '140px',
                  "align": "right",
                  "sortable": true,
                  "sum": true
                },
                {
                  "name": 'Performance %',
                  "columnName": 'Performance',
                  "width": '160px',
                  "align": "right",
                  "sortable": true,
                },
                {
                  "name": 'LY Sales',
                  "columnName": 'LYSales',
                  "width": '140px',
                  "align": "right",
                  "sortable": true,
                  "sum": true
                },
                {
                  "name": 'Growth %',
                  "columnName": 'Growth',
                  "width": '140px',
                  "align": "right",
                  "sortable": true,
                }
              ],
              "title": 'AgentName',
              "endpoint": "PG03.1",
              "parameters": [
                { "key": "FromMonth", "value": "2024" },
                { "key": "FromYear", "value": "1" },
                { "key": "ToMonth", "value": "2024" },
                { "key": "ToYear", "value": "1" },
                { "key": "ItemGroupCode", "value": "" },
                { "key": "ConfigTypeCode", "value": "" }
              ]
            },
            "context": {
              "point": {
                "onClick": {
  
                }
              }
            }
          }
        }
      },
      {
        "columns": 12,
        "rows": 2,
        "visual": {
          "id": 1,
          "type": "advancedTable",
          "colorTheme": "colorTheme1",
          "title": "PMR Sales",
          "binding": {
            "data": {
              "columns": [
                {
                  "name": 'PMR Code',
                  "columnName": 'AgentCode',
                  "width": '200px',
                  "align": "left",
                  "sortable": true,
                  "sum": false
                },
                {
                  "name": 'Employee Code',
                  "columnName": 'EmployeeCode',
                  "width": '200px',
                  "align": "left",
                  "sortable": true,
                  "sum": false
                },
                {
                  "name": 'PMR Name',
                  "columnName": 'AgentName',
                  "width": '250px',
                  "align": "left",
                  "sortable": true,
                  "sum": false
                },
                {
                  "name": 'Actual Sales',
                  "columnName": 'ActualSales',
                  "width": '140px',
                  "align": "right",
                  "sortable": true,
                  "sum": true
                },
                {
                  "name": 'Target Sales',
                  "columnName": 'TargetSales',
                  "width": '140px',
                  "align": "right",
                  "sortable": true,
                  "sum": true
                },
                {
                  "name": 'Performance %',
                  "columnName": 'Performance',
                  "width": '160px',
                  "align": "right",
                  "sortable": true,
                },
                {
                  "name": 'LY Sales',
                  "columnName": 'LYSales',
                  "width": '140px',
                  "align": "right",
                  "sortable": true,
                  "sum": true
                },
                {
                  "name": 'Growth %',
                  "columnName": 'Growth',
                  "width": '140px',
                  "align": "right",
                  "sortable": true,
                  "sum": true
                }
              ],
              "title": 'AgentName',
              "endpoint": "PG03.2",
              "parameters": [
                { "key": "FromMonth", "value": "2024" },
                { "key": "FromYear", "value": "1" },
                { "key": "ToMonth", "value": "2024" },
                { "key": "ToYear", "value": "1" },
                { "key": "ItemGroupCode", "value": "" },
                { "key": "ConfigTypeCode", "value": "" }
              ]
            },
            "context": {
              "point": {
                "onClick": {
  
                }
              }
            }
          }
        }
      }
    ]
  }